'use client';

interface Stat {
  value: string;
  label: string;
}

const stats: Stat[] = [
  { value: '20+', label: 'Years of Excellence' },
  { value: '3,800+', label: 'Cases Resolved' },
  { value: '$620M+', label: 'Recovered for Clients' },
];

export default function StatBar() {
  return (
    <section className="stat-bar" aria-label="Firm milestones">
      <div className="site-container stat-grid">
        {stats.map((stat, i) => (
          <div key={i}>
            <strong>{stat.value}</strong>
            <span>{stat.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
